export const isAndroid = () => {
    return window.navigator.userAgent.match(/Android/i);
};
export const isIos = () => {
    return window.navigator.userAgent.match(/iPhone|iPod/i);
};
export const isMobile = () => {
    return isAndroid() || isIos();
};
